<template>
  <div>
    <div class="d-flex justify-end sticky to-header">
      <v-btn
        v-if="hasRight('DEVICE_WRITE')"
        v-bind="$config.buttonAttrs.floating"
        :to="{ name: 'NewCamera' }"
        title="Hozzáadás"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>

    <h1 class="py-6">Kamera lista</h1>

    <v-expansion-panels class="mb-4" :mandatory="!!Object.values(search).find((e) => e !== '')">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col :cols="12" :sm="12" :md="4">
              <v-text-field
                label="Név"
                v-model="search.name"
                @input="searchEventHandler"
                @click:clear="searchEventHandler"
                hide-details
                clearable
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        :item-class="itemClass"
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            small
            fab
            text
            color="secondary"
            dark
            depressed
            class="rounded-sm m-2"
            :to="{ name: 'CameraEditor', params: { id: item.element_id } }"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('DEVICE_WRITE') && $root.user.filter_element == 1"
            small
            fab
            text
            color="secondary"
            dark
            depressed
            class="rounded-sm m-2"
            @click="editButtonInfo"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'CameraList',
      fetchItems: this.fetchCameras,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Név', value: 'name' },
          { text: 'IP cím', value: 'ip' },
          { text: 'Rendszám zónák', value: 'lpr_zones' },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: ''
      },
    };
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
      };
    },

    clearSearchFields() {
      this.search = {
        name: '',
      };
    },

    async fetchCameras() {
      this.loading = true;
      try {
        const response = await this.$http.post('cameras/list', this.options);
        this.dataTable.items = response.cameras;
        this.dataTable.itemsLength = response.cameras_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
      };
    },
  },
};
</script>
